import { useEffect, useRef, useState } from 'react'

interface ThresholdSliderProps {
  value: number              // server/effective value (0..1)
  onCommit: (v: number) => void
  disabled?: boolean         // true only when inherited/off — NEVER tie to mutation pending
  ariaLabel?: string
}

export function ThresholdSlider({ value, onCommit, disabled, ariaLabel }: ThresholdSliderProps) {
  const [drag, setDrag] = useState(value)
  const dragging = useRef(false)
  // Reconcile to server value only when NOT actively dragging (no thumb snap-back).
  useEffect(() => { if (!dragging.current) setDrag(value) }, [value])

  const commit = () => { dragging.current = false; if (drag !== value) onCommit(drag) }

  return (
    <div className="flex items-center gap-3">
      <input
        type="range" min={0} max={1} step={0.01}
        value={drag}
        disabled={disabled}
        aria-label={ariaLabel}
        onPointerDown={() => { dragging.current = true }}
        onChange={(e) => setDrag(parseFloat(e.target.value))}   // local only — no network
        onPointerUp={commit}
        onKeyUp={commit}
        onBlur={commit}
        className="flex-1 accent-primary disabled:opacity-50"
      />
      <span className="w-12 text-right text-sm tabular-nums">{Math.round(drag * 100)}%</span>
    </div>
  )
}
